/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Day_SeriesInputs */

const en_platform_day_series = /** @type {(inputs: Platform_Day_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every Tuesday at 18:00. The client books once and the dates fill in.`)
};

const pl_platform_day_series = /** @type {(inputs: Platform_Day_SeriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co wtorek o 18:00. Podopieczny rezerwuje raz, terminy dopisują się same.`)
};

/**
* | output |
* | --- |
* | "Every Tuesday at 18:00. The client books once and the dates fill in." |
*
* @param {Platform_Day_SeriesInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_day_series = /** @type {((inputs?: Platform_Day_SeriesInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Day_SeriesInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_day_series(inputs)
	return en_platform_day_series(inputs)
});